import * as Bixby from '$/core';

export type NewsAdminState = {
  error?: Bixby.Models.BixbyError;
  isLoading: boolean;
}

export const CREATE_NEWS_INPROGRESS = 'CREATE_NEWS_INPROGRESS';
export const CREATE_NEWS_SUCCESS = 'CREATE_NEWS_SUCCESS';
export const CREATE_NEWS_FAILURE = 'CREATE_NEWS_FAILURE';
export const REMOVE_NEWS_INPROGRESS = 'REMOVE_NEWS_INPROGRESS';
export const REMOVE_NEWS_SUCCESS = 'REMOVE_NEWS_SUCCESS';
export const REMOVE_NEWS_FAILURE = 'REMOVE_NEWS_FAILURE';
export const PUBLISH_NEWS_INPROGRESS = 'PUBLISH_NEWS_INPROGRESS';
export const PUBLISH_NEWS_SUCCESS = 'PUBLISH_NEWS_SUCCESS';
export const PUBLISH_NEWS_FAILURE = 'PUBLISH_NEWS_FAILURE';

interface CreateNewsInProgress extends Bixby.Models.BixbyAction<undefined, typeof CREATE_NEWS_INPROGRESS> {
  type: typeof CREATE_NEWS_INPROGRESS;
}

interface CreateNewsSuccess extends Bixby.Models.BixbyAction<undefined, typeof CREATE_NEWS_SUCCESS> {
  type: typeof CREATE_NEWS_SUCCESS;
}

interface CreateNewsFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof CREATE_NEWS_FAILURE> {
  type: typeof CREATE_NEWS_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface RemoveNewsInProgress extends Bixby.Models.BixbyAction<undefined, typeof REMOVE_NEWS_INPROGRESS> {
  type: typeof REMOVE_NEWS_INPROGRESS;
}

interface RemoveNewsSuccess extends Bixby.Models.BixbyAction<undefined, typeof REMOVE_NEWS_SUCCESS> {
  type: typeof REMOVE_NEWS_SUCCESS;
}

interface RemoveNewsFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof REMOVE_NEWS_FAILURE> {
  type: typeof REMOVE_NEWS_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface PublishNewsInProgress extends Bixby.Models.BixbyAction<undefined, typeof PUBLISH_NEWS_INPROGRESS> {
  type: typeof PUBLISH_NEWS_INPROGRESS;
}

interface PublishNewsSuccess extends Bixby.Models.BixbyAction<undefined, typeof PUBLISH_NEWS_SUCCESS> {
  type: typeof PUBLISH_NEWS_SUCCESS;
}

interface PublishNewsFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof PUBLISH_NEWS_FAILURE> {
  type: typeof PUBLISH_NEWS_FAILURE;
  payload: Bixby.Models.BixbyError;
}

export type NewsEarningsActionTypes =
  | CreateNewsInProgress
  | CreateNewsSuccess
  | CreateNewsFailure
  | RemoveNewsInProgress
  | RemoveNewsSuccess
  | RemoveNewsFailure
  | PublishNewsInProgress
  | PublishNewsSuccess
  | PublishNewsFailure;
